import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from '@react-router';
import App from './App';
import { routes } from './router';
import { ErrorBoundary } from './ErrorBoundary';
import globalWindow from '@shared/core/globals';
import '@shared/core/i18n/i18n';
import { FullPageLoaderProvider } from '@shared/components/JoyLogoLoader/FullPageLoaderProvider';
import { SuspenseWithPageLoader } from '@shared/core/react/SuspenseWithPageLoader';

export const appsCsr = async () => {
  ReactDOM.render(
    <ErrorBoundary>
      <FullPageLoaderProvider>
        <SuspenseWithPageLoader loaderKey="appCsr">
          <BrowserRouter>
            <App
              routes={routes}
              // MCP preview SSR-failure fallback: thread the injected preview globals into App — see MCP_PREVIEW.md#hydration-parity.
              forceSsr={globalWindow.__INITIAL_MCP_FORCE_SSR__}
              forceDraft={globalWindow.__INITIAL_MCP_FORCE_DRAFT__}
            />
          </BrowserRouter>
        </SuspenseWithPageLoader>
      </FullPageLoaderProvider>
    </ErrorBoundary>,
    document.getElementById('root'),
  );
};
